export default (theme) => ({
    dateWrapper: {
        '& .MuiTextField-root': {
            marginRight: '8px'
        },
        '& input#year': {
            minWidth: '60px'
        }
    }
});